const CommentsThread = {
	comments: 'Comentários'
}

export default CommentsThread;